import { useParams } from "react-router-dom";
import ResourceEditor from "components/cms/ResourceEditor";
import ArticleStack from "components/cms/ArticleStack";
import {
  addArticle,
  emptyArticle,
  getArticle,
  prepareArticle,
  updateArticle,
} from "api/article";

export default function ArticleEditPage() {
  const { id } = useParams();
  const isNew = !id || id === "new";

  return (
    <ResourceEditor
      id={id}
      isNew={isNew}
      empty={emptyArticle}
      load={getArticle}
      create={addArticle}
      update={updateArticle}
      prepare={prepareArticle}
      listHref="/admin/articles"
      label="article"
    >
      {(props) => <ArticleStack {...props} />}
    </ResourceEditor>
  );
}
